import { LoadingOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Card, Flex, Row, Space, Upload } from "antd";
import { MainLayout } from "components/layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/AdminCompany.module.css";
import * as service from "../services/adminApi";
import { getBase64 } from "components/elements/upload/Upload.utils";
import { dataURLtoFile } from "utils/helper";
import CompanyInfo from "components/elements/CompanyInfo";
import { Form, Formik } from "formik";
import Addressinformation from "components/elements/AddressInformation";
import ContactInfo from "components/elements/ContactInfo";
import infoSchema, {
    initialValues as infoInitialValues,
} from "../../company/schemas/companyProfileInfoSchema";
import { useNavigate } from "react-router-dom";

const AdminCreateCompany = ({
    infoValues = {},
    companyTypeOptions = [],
    provinceOptionsTh = [],
    provinceOptionsEn = [],
    districtOptionsTh = [],
    districtOptionsEn = [],
    subDistrictOptionsTh = [],
    subDistrictOptionsEn = [],
    handleProviceChange = () => { },
    handleDistrictChange = () => { },
    onCompanyCreateSubmit = () => { },
    getTaxCompanyOption = () => { },
    optionSearchTax = []
}) => {
    const { t } = useTranslation();
    const [imageUrl, setImageUrl] = useState();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb
                        items={[
                            { title: t("home.header"), href: "/admin/response_company" },
                            { title: t("response_company.label.add_company") },
                        ]} />
                    <h2>{t('response_company.label.add_company')}</h2>
                </Flex>

                <Card style={{ border: "solid 1px #EAECF0" }}>
                    <Formik
                        enableReinitialize
                        initialValues={{ ...infoInitialValues, ...infoValues }}
                        validationSchema={infoSchema}
                        onSubmit={onCompanyCreateSubmit}
                    >
                        {({ values, errors, setFieldValue, setTouched }) => {

                            const onAvatarChange = async (info) => {
                                setLoading(true);
                                const compressImg = await service.compressedImage({
                                    file: info.file
                                })
                                getBase64(compressImg.data, (url) => {
                                    setLoading(false);
                                    setFieldValue("companyLogo", dataURLtoFile(url));
                                    setImageUrl(url);
                                });
                            };

                            const onClearAvatar = (e) => {
                                e.stopPropagation();
                                setFieldValue("companyLogo", null);
                                setLoading(false);
                                setImageUrl(null);
                            };

                            const beforeUpload = (file) => {
                                return false;
                            };

                            const uploadButton = (
                                <button
                                    style={{
                                        border: 0,
                                        background: "none",
                                    }}
                                    type="button"
                                >
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div
                                        style={{
                                            marginTop: 8,
                                        }}
                                    >
                                        {t("common.upload")}
                                    </div>
                                </button>
                            );

                            const onProviceChange = (val) => {
                                handleProviceChange(val);
                                setFieldValue("districtId", null);
                                setFieldValue("subdistrictId", null);
                                setFieldValue("zipCode", null);
                                setTouched(
                                    {
                                        districtId: false,
                                        subdistrictId: false,
                                        zipCode: false,
                                    },
                                    false
                                );
                            };

                            const onDistrictChange = (val) => {
                                handleDistrictChange(val);
                                setFieldValue("subdistrictId", null);
                                setFieldValue("zipCode", null);
                                setTouched(
                                    {
                                        subdistrictId: false,
                                        zipCode: false,
                                    },
                                    false
                                );
                            };

                            const onSubDistrictChange = (_, selectedValue) => {
                                setFieldValue("zipCode", selectedValue.zipCode || null);
                                setTouched({ zipCode: false }, false);
                            };

                            return (
                                <Form>
                                    <Space style={{ width: "100%" }} direction="vertical" size={24}>
                                        <Flex justify="center">
                                            <Upload
                                                name="companyLogo"
                                                listType="picture-circle"
                                                className={styles.avatarUploader}
                                                showUploadList={false}
                                                beforeUpload={beforeUpload}
                                                onChange={async (info) => onAvatarChange(info)}
                                                action={null}
                                            >
                                                {imageUrl ? (
                                                    <>
                                                        <img
                                                            src={imageUrl}
                                                            alt="companyLogo"
                                                            className={styles.avatar}
                                                            style={{
                                                                width: "100%",

                                                            }}
                                                        />
                                                        <MinusCircleOutlined
                                                            className={styles.avatarMinusIcon}
                                                            onClick={onClearAvatar}
                                                        />

                                                    </>
                                                ) : (
                                                    uploadButton
                                                )}
                                            </Upload>
                                        </Flex>

                                        <CompanyInfo
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            getTaxConpanyOption={getTaxCompanyOption}
                                            optionSearchTax={optionSearchTax}
                                            companyTypeOptions={companyTypeOptions}
                                        />

                                        <Addressinformation
                                            provinceOptionsTh={provinceOptionsTh}
                                            provinceOptionsEn={provinceOptionsEn}
                                            districtOptionsTh={districtOptionsTh}
                                            districtOptionsEn={districtOptionsEn}
                                            subDistrictOptionsTh={subDistrictOptionsTh}
                                            subDistrictOptionsEn={subDistrictOptionsEn}
                                            onProviceChange={(_, item) => {
                                                onProviceChange(item?.provinceCode)
                                            }}
                                            onDistrictChange={(_, item) => {
                                                onDistrictChange(item?.districtCodeId)
                                            }}
                                            onSubDistrictChange={onSubDistrictChange}
                                        />

                                        <ContactInfo />

                                        <Row justify="end">
                                            <Space size={10}>
                                                <Button type="default" style={{ borderRadius: "8px" }} size="large"
                                                    onClick={() => {
                                                        setFieldValue("");
                                                        navigate("/admin/response_company");
                                                    }}
                                                >
                                                    {t("common.cancel").toUpperCase()}
                                                </Button>
                                                <Button htmlType="submit" style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", border: "none", color: "white" }} size="large">
                                                    {t("common.create").toUpperCase()}
                                                </Button>
                                            </Space>
                                        </Row>
                                    </Space>
                                </Form>
                            );
                        }}
                    </Formik>
                </Card>
            </Space>
        </MainLayout>
    )
}

export default AdminCreateCompany;